import { creatorbase, PaypalTransactionStatus, tipalti } from '@round/api';
import capitalize from 'lodash/capitalize';

type PaymentStatus =
    | creatorbase.PostPaymentRequestStatus
    | PaypalTransactionStatus
    | creatorbase.PostPaymentStatus
    | tipalti.TipaltiTransactionStatus;
export const getPaymentStatusLabel = (status: PaymentStatus) => {
    const labels: Record<PaymentStatus, string> = {
        PAID: 'Paid',
        SUCCESS: 'Success',
        CANCELLED: 'Cancelled',
        UNCLAIMED: 'Unclaimed',
        RETURNED: 'Returned',
        REFUNDED: 'Refunded',
        REVERSED: 'Reversed',
        ONHOLD: 'On Hold',
        PENDING: 'Pending',
        BLOCKED: 'Blocked',
        FAILED: 'Failed',
        UNPAID: 'Unpaid',
        REQUESTED: 'Requested',
        IN_PROGRESS: 'In Progress',
    };

    return labels[status] || capitalize(status.replace(/_/g, ' '));
};

export const getPaymentStatusStyleString = (status: PaymentStatus) => {
    const statusStyleMap: Record<string, (typeof status)[]> = {
        success: ['PAID', 'SUCCESS'],
        positive: ['UNCLAIMED'],
        cancelled: ['CANCELLED'],
        completed: ['RETURNED', 'REFUNDED', 'REVERSED'],
        alert: ['BLOCKED', 'FAILED'],
        pending: ['PENDING', 'REQUESTED', 'IN_PROGRESS'],
        warning: ['ONHOLD'],
        neutral: ['UNPAID'],
    };

    return Object.entries(statusStyleMap).find(([_, statuses]) => statuses.includes(status))?.[0] || 'neutral';
};
